import { render, staticRenderFns } from "./PermissionDetailOverlay.vue?vue&type=template&id=0ec025c2"
import script from "./PermissionDetailOverlay.vue?vue&type=script&lang=js"
export * from "./PermissionDetailOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports